import React from "react";
import NotFound404 from "@/assets/404.webp";
import { useLocation } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  return (
    <div className="w-full h-full max-w-screen max-h-screen">
      <img
        src={NotFound404}
        className={`w-full ${
          location.pathname.includes("media") ? "h-full" : "h-[400px]"
        }  max-w-screen max-h-screen object-cover`}
      />
    </div>
  );
};

export default NotFound;
